'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

module.exports = (0, _createReactClass2.default)({
  displayName: 'TabPanel',

  propTypes: {
    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]),
    className: _propTypes2.default.string,
    id: _propTypes2.default.string,
    selected: _propTypes2.default.bool,
    style: _propTypes2.default.object,
    tabId: _propTypes2.default.string
  },

  contextTypes: {
    forceRenderTabPanel: _propTypes2.default.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      selected: false,
      id: null,
      tabId: null
    };
  },
  render: function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        selected = _props.selected,
        id = _props.id,
        tabId = _props.tabId,
        style = _props.style,
        attributes = _objectWithoutProperties(_props, ['className', 'children', 'selected', 'id', 'tabId', 'style']);

    return _react2.default.createElement(
      'div',
      _extends({}, attributes, {
        className: (0, _classnames2.default)('ReactTabs__TabPanel', className, {
          'ReactTabs__TabPanel--selected': selected
        }),
        role: 'tabpanel',
        id: id,
        'aria-labelledby': tabId,
        style: _extends({}, style, { display: selected ? null : 'none' })
      }),
      this.context.forceRenderTabPanel || selected ? children : null
    );
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/react-tabs/lib/components/TabPanel.js
// module id = 1636
// module chunks = 0